import { render, staticRenderFns } from "./FavIndicator.vue?vue&type=template&id=66394db7&scoped=true&"
import script from "./FavIndicator.vue?vue&type=script&lang=js&"
export * from "./FavIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66394db7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/FavIndicator.vue
// module id = null
// module chunks = 